import { rankingCommonConfig } from './common'
import type { RankingPageConfig } from './types'
import { resources as brandResources } from '@/config/brands'

export const theme = {
  rankGradient: 'linear-gradient(90deg, #FFA81E 0%, #FF771C 100%)',
} as const

export const resources = {
  homeBg: '/images/novelarc/home-bg.webp',
  spikeletL: '/images/novelarc/ranking/spikelet_l.png',
  spikeletR: '/images/novelarc/ranking/spikelet_r.png',
  goldMedal: brandResources.medals.goldMedal,
  silverMedal: brandResources.medals.silverMedal,
  bronze: brandResources.medals.bronze,
  medal: brandResources.medals.medal,
} as const

export const rankingConfig: RankingPageConfig = {
  theme,
  resources,
  texts: rankingCommonConfig.texts,
}
